import { get } from "aws-amplify/api";
import { API_NAME_VELAVU, operationToJSON, } from "../util/amplify-utils";
export class VelavuAPIDeviceModels {
    /**
     * Get all device models
     * @returns Promise<DeviceModel[]> List of all device models
     */
    async getAllDeviceModels() {
        const operation = get({
            apiName: API_NAME_VELAVU,
            path: "/devicemodels"
        });
        return operationToJSON(operation);
    }
}
export default VelavuAPIDeviceModels;
//# sourceMappingURL=velavu-api-device-models.js.map